<template>
  <DonutChart
    :donutData="donutData"
    :tag="tag"
    :index="index"
    :theme="theme"
    :userIsAdminForCurrentGroupOrSuperAdmin="
      userIsAdminForCurrentGroupOrSuperAdmin
    "
    :onClickCallback="
      userIsAdminForCurrentGroupOrSuperAdmin ? onClickTagTitle : null
    "
  />
</template>

<script>
import DonutChart from '@/components/shared/charts/DonutChart.vue'
import { getDonutDataForStatItem } from '@/components/shared/charts/chart-helpers'

export default {
  name: 'TagDonutChart',
  components: { DonutChart },
  props: {
    // Shared props
    onOpenTagDetails: {
      type: Function,
      default: () => null
    },
    index: String,
    surveyName: String,
    tag: {
      type: Object,
      required: true
    },
    tagDescription: String,
    tagTitle: String,
    theme: String,
    userIsAdminForCurrentGroupOrSuperAdmin: {
      type: Boolean,
      default: false
    },
    // Props specific to TagChart
    tagShouldBeZeroToHundred: {
      type: Boolean,
      default: false
    },
    tagShouldBePercentage: {
      type: Boolean,
      default: false
    },
    shouldShowResultsPerPerson: {
      type: Boolean,
      default: false
    },
    // Define a prop to determine chart type: 'enps' or 'tag'
    chartType: {
      type: String,
      default: 'tag',
      validator: (value) => ['enps', 'tag'].includes(value)
    }
  },
  computed: {
    donutData() {
      return getDonutDataForStatItem({
        statItem: this.tag,
        title: this.tagTitle,
        description: this.tagDescription,
        theme: this.theme,
        chartType: this.chartType,
        shouldBeZeroToHundred: this.tagShouldBeZeroToHundred,
        isPercentage: this.tagShouldBePercentage,
        localeNumber: this.$localeNumber,
        t: this.$t
      })
    }
  },
  methods: {
    onClickTagTitle() {
      this.onOpenTagDetails(this.tag)
    }
  }
}
</script>
